/**
 * Quick Send Buttons Component
 *
 * Displays quick-send buttons for each available target panel.
 * Provides a binary, deterministic way to route the current message
 * to a specific panel without relying on AI interpretation.
 *
 * When a button is clicked, the current draft message is sent
 * directly to the target panel.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { QuickSendTarget } from "@/types/splitView";
interface QuickSendButtonsProps {
  targets: QuickSendTarget[];
  currentDraft: string;
  onQuickSend: (targetPanelId: 'left' | 'right', message: string) => void;
  disabled?: boolean;
  currentPanelId: 'left' | 'right';
}
export default function QuickSendButtons(t0) {
  const $ = _c(32);
  const {
    targets,
    currentDraft,
    onQuickSend,
    disabled: t1,
    currentPanelId
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== currentDraft || $[1] !== currentPanelId || $[2] !== disabled || $[3] !== onQuickSend || $[4] !== targets) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t8;
      if ($[11] !== currentPanelId) {
        t8 = target => target.panelId !== currentPanelId && target.threadId !== null;
        $[11] = currentPanelId;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      const availableTargets = targets.filter(t8);
      if (availableTargets.length === 0) {
        t7 = null;
        break bb0;
      }
      let t9;
      if ($[13] !== currentDraft || $[14] !== onQuickSend) {
        t9 = targetPanelId => {
          if (!currentDraft.trim()) {
            return;
          }
          onQuickSend(targetPanelId, currentDraft);
        };
        $[13] = currentDraft;
        $[14] = onQuickSend;
        $[15] = t9;
      } else {
        t9 = $[15];
      }
      const handleQuickSend = t9;
      t6 = "flex items-center gap-2 border-t border-white/20 bg-white/20 backdrop-blur-sm px-4 py-2";
      t4 = "flex items-center gap-2";
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <span className="text-xs font-medium text-foreground/60">Quick Send:</span>;
        $[16] = t5;
      } else {
        t5 = $[16];
      }
      t2 = "flex gap-2";
      let t10;
      if ($[17] !== currentDraft || $[18] !== disabled || $[19] !== handleQuickSend) {
        t10 = target_0 => <button key={target_0.panelId} onClick={() => handleQuickSend(target_0.panelId)} disabled={disabled || !currentDraft.trim()} className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors ${disabled || !currentDraft.trim() ? "cursor-not-allowed bg-white/30 text-foreground/40" : "bg-sky text-foreground hover:bg-sky/80 active:bg-sky/70"}`} title={`Send current message directly to ${target_0.panelName}`}><svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" /></svg><span>→ {target_0.panelName}</span></button>;
        $[17] = currentDraft;
        $[18] = disabled;
        $[19] = handleQuickSend;
        $[20] = t10;
      } else {
        t10 = $[20];
      }
      t3 = availableTargets.map(t10);
    }
    $[0] = currentDraft;
    $[1] = currentPanelId;
    $[2] = disabled;
    $[3] = onQuickSend;
    $[4] = targets;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="ml-auto"><span className="text-xs text-foreground/50">Direct routing (no AI interpretation)</span></div>;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t6 || $[30] !== t9) {
    t11 = <div className={t6}>{t9}{t10}</div>;
    $[29] = t6;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}